import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero (approx 500px)
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-slate-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 md:hidden animate-in slide-in-from-bottom duration-300" data-id="element-244">
      <div className="flex items-center justify-between gap-4 max-w-md mx-auto" data-id="element-245">
        <div className="flex flex-col" data-id="element-246">
          <span className="text-xs text-slate-500 font-medium uppercase" data-id="element-247">
            Oferta Especial
          </span>
          <div className="flex items-baseline gap-2" data-id="element-248">
            <span className="text-xs text-slate-400 line-through" data-id="element-249">$78.000</span>
            <span className="font-bold text-slate-900" data-id="element-250">$39.000 COP</span>
          </div>
        </div>
        <Button size="lg" className="flex-1 shadow-lg shadow-blue-600/20" onClick={() => window.open('https://mapaclaro.com/cart/52341272543521:1', '_blank')} data-id="element-251">
          Quiero mi Mapa
        </Button>
      </div>
    </div>;
}